import { Modal } from '@aloft/toolkit-sui';

export const BypassComplianceCheckModal = ({
  isOpen,
  onClose,
  onCertifyAnyway,
}: {
  isOpen: boolean;
  onClose: () => void;
  onCertifyAnyway: () => void;
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Bypass Compliance Check"
    secondaryAction={{
      text: 'Certify Anyway',
      onClick: onCertifyAnyway,
    }}
    primaryAction={{
      text: 'Back to Review',
      onClick: onClose,
    }}
  >
    Certifying without resolving compliance warnings may lead to additional client revisions and an
    internal audits by the Appraisify Team.
  </Modal>
);
